"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinearProgressIndicator = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function LinearProgressIndicator(props) {
    var progress = props.progress;
    return (react_1.default.createElement(core_ui_1.StepProgressIndicator, { steps: progress.stepLabels, completed: progress.completedSteps, disabled: progress.disabledSteps, active: progress.currentStep }));
}
exports.LinearProgressIndicator = LinearProgressIndicator;
